var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:[
    'tw-inline-flex tw-rounded-full tw-px-2 tw-py-0.5 tw-font-semibold tw-leading-5',
    {
      'tw-bg-green-100 tw-text-green-800': _vm.variant === 'success',
      'tw-bg-red-100 tw-text-red-800': _vm.variant === 'error',
      'tw-bg-yellow-100 tw-text-yellow-800': _vm.variant === 'warning',
      'tw-bg-blue-100 tw-text-blue-800': _vm.variant === 'info',
      'tw-bg-gray-100 tw-text-gray-800': _vm.variant === 'default',
    },
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }